import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ModalWindowParameters} from '../../modal-window-parameters';
import {ModalWindowResponse} from '../../modal-window-response';

@Component({
  selector: 'app-modal-window-confirmation',
  templateUrl: './modal-window-confirmation.component.html',
  styleUrls: ['./modal-window-confirmation.component.scss']
})
export class ModalWindowConfirmationComponent implements OnInit {

  @Input() modalWindowParameters: ModalWindowParameters;
  @Output() modalWindowResponse: EventEmitter<ModalWindowResponse> = new EventEmitter<ModalWindowResponse>();

  constructor() { }

  ngOnInit() {
  }
  onCancelClick() {
    this.modalWindowResponse.next({confirmed: false});
  }
  onApplyClick() {
    this.modalWindowResponse.next({confirmed: true});
  }
}
